import type { Dictionary } from '../i18n.js';

export const race: Dictionary = {
  // hud.ts
  'of {count}': 'z {count}',
  'Zoom in (])': 'Przybliż (])',
  'Zoom out ([)': 'Oddal ([)',
  'North-up / heading-up (N)': 'Północ u góry / kierunek jazdy (N)',
  // perfGraph.ts
  '{fps} fps': '{fps} fps',
  '{ms} ms': '{ms} ms',
  ping: 'ping',
  '{tris}k tris': '{tris} tys. trójkątów',
  'Race complete': 'Wyścig zakończony',
  Standings: 'Klasyfikacja',
  Position: 'Pozycja',
  Time: 'Czas',
  Checkpoint: 'Punkt kontrolny',
  'Watching {name}': 'Oglądasz: {name}',
  'Finish line': 'Linia mety',
  '{m} m away': 'za {m} m',
  '{km} km away': 'za {km} km',
  GO: 'START',
  'GO!': 'START!',
  'Whole region, north up — press N to follow your car': 'Cały obszar, północ u góry — naciśnij N, żeby śledzić swoje auto',
  'Following your car — press N for the whole region': 'Śledzisz swoje auto — naciśnij N, żeby zobaczyć cały obszar',
  'Race {n} of {total} — {title}': 'Wyścig {n} z {total} — {title}',
  Driver: 'Kierowca',
  Gates: 'Bramki',
  Pts: 'Pkt',
  left: 'poza grą',
  'Standings · {n} races to go': {
    one: 'Klasyfikacja · jeszcze jeden wyścig',
    few: 'Klasyfikacja · jeszcze {n} wyścigi',
    many: 'Klasyfikacja · jeszcze {n} wyścigów',
  },

  // staging.ts
  'Get ready': 'Przygotuj się',
  "I'm ready": 'Zgłoś gotowość',
  'the lights wait for you': 'światła czekają na ciebie',
  'Start now': 'Startuj teraz',
  'On the grid': 'Na starcie',
  'Race {n} of {total}': 'Wyścig {n} z {total}',
  'Downloading the world · {names} are not on the grid yet': {
    one: 'Pobieranie świata · {names} nie jest jeszcze na starcie',
    few: 'Pobieranie świata · {names} nie są jeszcze na starcie',
    many: 'Pobieranie świata · {names} nie są jeszcze na starcie',
  },
  '{ready}/{total} ready · waiting for {names}': '{ready}/{total} w gotowości · czekamy na: {names}',
  'Everyone is ready — lights out shortly.': 'Wszyscy gotowi — zaraz zgasną światła.',
  "You're ready ✓": 'Gotowość zgłoszona ✓',
  'tap to cancel': 'naciśnij, żeby cofnąć',
  downloading: 'pobiera',
  'no world': 'brak świata',
  ready: 'w gotowości',
  waiting: 'czeka',
  '{first} and {last}': '{first} i {last}',

  // podium.ts
  '{name} · {n} races': {
    one: '{name} · {n} wyścig',
    few: '{name} · {n} wyścigi',
    many: '{name} · {n} wyścigów',
  },
  'No result': 'Brak wyniku',
  'Nobody finished the cup.': 'Nikt nie ukończył pucharu.',
  'You win the cup with {n} points': {
    one: 'Wygrywasz puchar z dorobkiem {n} punktu',
    few: 'Wygrywasz puchar z dorobkiem {n} punktów',
    many: 'Wygrywasz puchar z dorobkiem {n} punktów',
  },
  'wins the cup with {n} points': {
    one: 'wygrywa puchar z dorobkiem {n} punktu',
    few: 'wygrywa puchar z dorobkiem {n} punktów',
    many: 'wygrywa puchar z dorobkiem {n} punktów',
  },
  ' — on countback': ' — przy równej liczbie punktów',
  ' — by {n}': {
    one: ' — o {n} punkt',
    few: ' — o {n} punkty',
    many: ' — o {n} punktów',
  },
  '{n} pts': '{n} pkt',
  'Race the cup again': 'Powtórz puchar',
  'Back to lobby': 'Wróć do lobby',
  'Waiting for the host…': 'Czekamy na gospodarza…',
  'Leave race': 'Opuść wyścig',

  // chat.ts
  'Say something': 'Napisz coś',
  Chat: 'Czat',
  'Message… (Enter to send, Esc to cancel)': 'Wiadomość… (Enter wysyła, Esc anuluje)',
  Send: 'Wyślij',
  'crossed the finish line · {time}': 'na mecie · {time}',
  'crossed the finish line': 'na mecie',

  // pauseMenu.ts
  Drive: 'Jazda',
  Space: 'Spacja',
  Handbrake: 'Hamulec ręczny',
  'Look behind': 'Spójrz do tyłu',
  'Horn — the others hear it': 'Klakson — inni go słyszą',
  'Respawn on the route': 'Wróć na trasę',
  'Whole region / follow the car': 'Cały obszar / śledzenie auta',
  'Zoom the map': 'Przybliż / oddal mapę',
  'Street map': 'Mapa z ulicami',
  'Chase / aerial camera': 'Kamera zza auta / z lotu ptaka',
  Mute: 'Wycisz',
  'This menu': 'To menu',
  'Close (Esc)': 'Zamknij (Esc)',
  Sound: 'Dźwięk',
  Controls: 'Sterowanie',
  Connection: 'Połączenie',
  'Back to the race': 'Wróć do wyścigu',
  'Back to the drive': 'Wróć do jazdy',

  // touchControls.ts
  'Rotate your device to race': 'Obróć urządzenie, żeby jechać',
  Throttle: 'Gaz',
  Brake: 'Hamulec',
  Horn: 'Klakson',
  Menu: 'Menu',

  // bigMap.ts
  'Follow your car': 'Śledź swoje auto',
};
